type TranslateFn = (key: string, params?: Record<string, string | number>) => string;

const MONTH_MAP: Record<string, number> = {
  jan: 1,
  january: 1,
  feb: 2,
  february: 2,
  mar: 3,
  march: 3,
  apr: 4,
  april: 4,
  may: 5,
  jun: 6,
  june: 6,
  jul: 7,
  july: 7,
  aug: 8,
  august: 8,
  sep: 9,
  sept: 9,
  september: 9,
  oct: 10,
  october: 10,
  nov: 11,
  november: 11,
  dec: 12,
  december: 12,
};

const WEEKDAY_MAP: Record<string, string> = {
  mon: 'common.weekdaysShort.mon',
  monday: 'common.weekdaysShort.mon',
  tue: 'common.weekdaysShort.tue',
  tues: 'common.weekdaysShort.tue',
  tuesday: 'common.weekdaysShort.tue',
  wed: 'common.weekdaysShort.wed',
  wednesday: 'common.weekdaysShort.wed',
  thu: 'common.weekdaysShort.thu',
  thur: 'common.weekdaysShort.thu',
  thurs: 'common.weekdaysShort.thu',
  thursday: 'common.weekdaysShort.thu',
  fri: 'common.weekdaysShort.fri',
  friday: 'common.weekdaysShort.fri',
  sat: 'common.weekdaysShort.sat',
  saturday: 'common.weekdaysShort.sat',
  sun: 'common.weekdaysShort.sun',
  sunday: 'common.weekdaysShort.sun',
};

export function localizeChartLabel(label: string | null | undefined, t: TranslateFn): string {
  if (!label) return '';

  return label.replace(/[A-Za-z]+/g, (token) => {
    const normalized = token.toLowerCase();
    const monthNumber = MONTH_MAP[normalized];
    if (monthNumber) {
      const translated = t(`common.monthsShort.${monthNumber}`);
      return translated !== `common.monthsShort.${monthNumber}` ? translated : token;
    }

    const weekdayKey = WEEKDAY_MAP[normalized];
    if (weekdayKey) {
      const translated = t(weekdayKey);
      return translated !== weekdayKey ? translated : token;
    }

    return token;
  });
}
